"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTemplateSurface = void 0;
const typeguard_1 = require("../types/typeguard");
const Surface_1 = require("./Surface");
const templateSurfaceRuleSet = Object.assign(Object.assign({}, Surface_1.surfaceRuleSet), {
  x: typeguard_1.isNumber,
  y: typeguard_1.isNumber,
  design_overlay: (0, typeguard_1.optional)(typeguard_1.isString),
  border_radius: (0, typeguard_1.optional)(typeguard_1.isNumber)
});
const isTemplateSurface = ts => (0, typeguard_1.isType)(ts, templateSurfaceRuleSet);
exports.isTemplateSurface = isTemplateSurface;